import {useController, useFormContext} from "react-hook-form";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Input, Space} from "antd";
import {SessionSubGenInfoNameFormFieldProps} from "./types";
import {useEffect, useState} from "react";
import type {FocusEvent} from "react";
import slug from "slug";
import {SessionGenInfoFormFields} from "../../types";

export function SessionSubGenInfoNameFormField({
  id,
  label,
  placeholder,
}: SessionSubGenInfoNameFormFieldProps) {
  const {control, setValue, clearErrors} = useFormContext<SessionGenInfoFormFields>();

  const {field, fieldState} = useController({
    name: "name",
    control,
  });
  const fieldValue = field.value as string | undefined;

  const [nameValue, setNameValue] = useState<string | undefined>(fieldValue);

  useEffect(() => {
    setNameValue(fieldValue);
  }, [fieldValue]);

  function handleBlur(e: FocusEvent<HTMLInputElement, Element>) {
    field.onChange(e);
    field.onBlur();
  }

  function handleChange(e: FocusEvent<HTMLInputElement, Element>) {
    setNameValue(e.target.value);
    if (e.target.value.length > 0) {
      clearErrors("slug");
    }
    setValue("slug", slug(e.target.value, {remove: /[*+~.()'"!:@]/g}));
  }

  return (
    <div>
      <FormField
        id={id}
        label={label}
        renderInput={(id) => (
          <Space direction="vertical" size={16} style={{display: "flex"}}>
            <Input
              id={id}
              status={fieldState.error?.message ? "error" : ""}
              value={nameValue}
              onChange={handleChange}
              onBlur={handleBlur}
              size="large"
              placeholder={placeholder}
              ref={field.ref}
            />
            <FormFieldError errorMessage={fieldState.error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
